import React, { useContext } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Plate from './plate'
import context from '../../../context'

export default function Buyer() {
  const {
    superior: {
      buyer: { global, branded, quality },
    },
    lang,
  } = useContext(context)
  return (
    <section className={styles.buyer}>
      <span className={classnames(styles.caption, styles[lang])} />
      <ul className={styles.icons}>
        <li className={styles.icon}>
          <em className={styles.global}></em>
        </li>
        <li className={styles.icon}>
          <em className={styles.branded}></em>
        </li>
        <li className={styles.icon}>
          <em className={styles.quality}></em>
        </li>
      </ul>
      <div className={styles.plates}>
        <Plate {...global} />
        <Plate {...branded} />
        <Plate {...quality} />
      </div>
    </section>
  )
}
